var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.499,
    height: 65.499
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 77",
    transform: "translate(-624 -1583.362)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 32.749,
    cy: 32.749,
    r: 32.749,
    transform: "translate(624 1583.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 89",
    d: "m650.344 1631.818.34-32.131 21.335 16.33Z",
    fill: "currentColor"
  }))));
};
export default SvgPlayIcon;